import { useEffect, useState } from 'react';

/**
 * «2Д 30Ч 50М» до `targetAt`. `null` на входе — отсчитывать нечего.
 *
 * Чистая, чтобы её можно было проверить юнитом: компонентных тестов
 * в проекте нет намеренно (скилл `unit-tests`), а сам хук проверяется e2e.
 */
export function chapterCountdown(
  targetAt: string | null,
  now: number,
): string | null {
  if (targetAt === null) return null;

  const totalMinutes = Math.max(
    0,
    Math.floor((new Date(targetAt).getTime() - now) / 60_000),
  );
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;
  return `${String(days)}Д ${String(hours)}Ч ${String(minutes)}М`;
}

/**
 * Отсчёт до следующей Главы, тикает раз в минуту.
 *
 * `null` (Глава последняя в сезоне) не заводит интервал. Принимать `null`
 * обязательно: хук вызывается до ранних `return` компонента и условным
 * быть не может.
 */
export function useChapterCountdown(targetAt: string | null): string | null {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (targetAt === null) return;

    const id = window.setInterval(() => {
      setNow(Date.now());
    }, 60_000);
    return () => {
      window.clearInterval(id);
    };
  }, [targetAt]);

  return chapterCountdown(targetAt, now);
}
